import { TRADING_GROUP_ENTITY_CONTEXT } from '@moment/sorm-client-data-access/entity-context'
import { sormQuery } from '@moment/sorm-client-data-access/query-builder'

import { SORM_MAX_QUERY_LIMIT } from '@/shared/sorm/filter-options-query'

const USER_TRADING_GROUPS_QUERY_NAME = 'user_trading_groups'

const TRADING_GROUP_FIELDS = [
  { entity: 'TradingGroup', field: 'id' },
  { entity: 'TradingGroup', field: 'name' },
  { entity: 'TradingGroup', field: 'is_default' },
] as const

/** The trading groups the caller can see, default first, in the legacy list's order. */
export const userTradingGroupsQuery = sormQuery(
  'TradingGroup',
  TRADING_GROUP_ENTITY_CONTEXT,
)
  .queryName(USER_TRADING_GROUPS_QUERY_NAME)
  .fields(TRADING_GROUP_FIELDS)
  .sortBy([
    { entity: 'TradingGroup', field: 'is_default', direction: 'desc' },
    { entity: 'TradingGroup', field: 'id', direction: 'asc' },
  ])
  // SORM returns 100 rows unless asked; the legacy risk-group list is unbounded.
  .limit(SORM_MAX_QUERY_LIMIT)
